/**
 * CUSTOMER-R4.7-A — client mirror of payment timing (not a payment method).
 */
export type CustomerPaymentTiming = "immediate" | "after_manager_confirmation";

export function normalizePaymentTiming(raw: string | null | undefined): CustomerPaymentTiming {
  const v = String(raw ?? "")
    .trim()
    .toLowerCase();
  if (v === "after_manager_confirmation" || v === "confirm_availability_first") {
    return "after_manager_confirmation";
  }
  return "immediate";
}

/**
 * CUSTOMER-R4.10 — locked only while top is still `new` (pre-confirm).
 * After manager confirms availability (accepted+), payment unlocks.
 */
export function isAwaitingManagerAvailability(
  timing: CustomerPaymentTiming | null | undefined,
  paymentStatus: string | null | undefined,
  orderTopStatus: string | null | undefined,
): boolean {
  if (normalizePaymentTiming(timing) !== "after_manager_confirmation") return false;
  const top = String(orderTopStatus ?? "").trim().toLowerCase();
  if (top === "canceled" || top === "cancelled" || top === "completed") return false;
  if (top !== "new" && top !== "") return false;
  const pay = String(paymentStatus ?? "").trim().toLowerCase();
  if (
    pay.includes("paid") ||
    pay === "payment_confirmed_bank_iban" ||
    pay === "refund_pending" ||
    pay === "refunded"
  ) {
    return false;
  }
  return true;
}
